/**
 * Map used to redirect to specific url from SSO endpoint
 */
export const redirectUrlMap = new Map()
  .set('performance', '/performance')
  .set('documents', '/docvault')
  .set('accounts', '/accounts');
